"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _moment = _interopRequireDefault(require("moment"));

var _react = _interopRequireWildcard(require("react"));

var _reactJss = _interopRequireDefault(require("react-jss"));

var _Calendar = _interopRequireDefault(require("./Calendar"));

var _ClickOutside = _interopRequireDefault(require("./ClickOutside"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var styles = {
  calendarButtonStyle: function calendarButtonStyle(props) {
    return _objectSpread({
      display: 'flex',
      alignItems: 'center',
      cursor: 'pointer',
      padding: 10,
      fontSize: 14,
      borderRadius: 5
    }, props.style.calendarButtonStyle);
  },
  calendarButtonImage: function calendarButtonImage(props) {
    return _objectSpread({
      paddingRight: 10,
      width: 25
    }, props.style.calendarButtonImage);
  }
};

var DateCalendar =
/*#__PURE__*/
function (_Component) {
  _inherits(DateCalendar, _Component);

  function DateCalendar() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, DateCalendar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(DateCalendar)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      displayCalendar: false,
      inputDate: null
    });

    _defineProperty(_assertThisInitialized(_this), "changeInputDate", function (date) {
      var getSelectedDate = _this.props.getSelectedDate;

      _this.setState({
        inputDate: date
      }, function () {
        getSelectedDate(date);

        _this.toggleCalendar();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggleCalendar", function () {
      var open = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var callback = _this.props.callback;

      _this.setState({
        displayCalendar: open
      });

      if (callback && typeof callback === "function") {
        callback(open);
      }
    });

    return _this;
  }

  _createClass(DateCalendar, [{
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      var _this$props = this.props,
          getSelectedDate = _this$props.getSelectedDate,
          setDate = _this$props.setDate,
          minDate = _this$props.minDate;
      var now = (0, _moment.default)().set({
        hour: 0,
        minute: 0,
        second: 0,
        millisecond: 0
      });

      if (minDate !== undefined) {
        var startDate = (0, _moment.default)(minDate).set({
          hour: 0,
          minute: 0,
          second: 0,
          millisecond: 0
        });
        if (now < startDate) now = startDate;
      }

      if (setDate) {
        this.setState({
          inputDate: (0, _moment.default)(setDate)
        });
      } else {
        this.setState({
          inputDate: now
        }, function () {
          getSelectedDate(now);
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          arrow = _this$props2.arrow,
          classes = _this$props2.classes,
          lang = _this$props2.lang,
          style = _this$props2.style,
          systemUS = _this$props2.systemUS,
          image = _this$props2.image,
          todayTxt = _this$props2.todayTxt,
          minDate = _this$props2.minDate,
          maxDate = _this$props2.maxDate;
      var day = this.state.inputDate;
      var date = systemUS ? this.state.inputDate.format('MM/DD/YYYY') : this.state.inputDate.format('DD/MM/YYYY');

      if (day.format('DD/MM/YYYY') === (0, _moment.default)().format('DD/MM/YYYY')) {
        date = todayTxt;
      }

      return _react.default.createElement(_ClickOutside.default, {
        clickOutside: this.toggleCalendar
      }, _react.default.createElement("div", {
        className: classes.calendarButtonStyle,
        onClick: function onClick() {
          return _this2.toggleCalendar(true);
        }
      }, _react.default.createElement("img", {
        src: image,
        className: classes.calendarButtonImage,
        alt: "calendar"
      }), date), _react.default.createElement(_Calendar.default, {
        changeInputDate: this.changeInputDate,
        display: this.state.displayCalendar,
        dateSelected: this.state.inputDate,
        lang: lang,
        arrow: arrow,
        style: style,
        systemUS: systemUS,
        todayTxt: todayTxt,
        minDate: minDate,
        maxDate: maxDate
      }));
    }
  }]);

  return DateCalendar;
}(_react.Component);

var _default = (0, _reactJss.default)(styles)(DateCalendar);

exports.default = _default;